import { render } from "./BaseTooltip.vue?vue&type=template&id=4be8463a&scoped=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"

import "./BaseTooltip.vue?vue&type=style&index=0&id=4be8463a&lang=scss"
import "./BaseTooltip.vue?vue&type=style&index=1&id=4be8463a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be8463a"]])

export default __exports__